<template>
  <div class="container1" v-wechat-title="$store.state.region.re_name +'-视频'">
    <new-top :title="'短视频'"></new-top>
    <div style="padding-top: 44px; background: rgb(0, 0, 0)" class="bjfg">
      <div v-if="swiperIndex != -1">
        <van-swipe
          style="height: calc(100vh - 44px)"
          vertical
          :show-indicators="false"
          :loop="false"
          :initial-swipe="swiperIndex"
          @change="changeClick"
        >
          <van-swipe-item v-for="(item, index) in videoList" :key="item.id">
            <video
              @play="videoPaly"
              class="videos"
              :id="item.id"
              :src="item.video_url"
              controls
              loop
              width="100%"
              controlslist="nodownload"
            ></video>
            <div class="title">
              {{ item.video_name }}
            </div>
            <div v-if="item.user_like == 1">
              <div
                class="zan"
                :class="item.user_like == 1 ? 'heartAnimation' : ''"
              >
                <div @click="dian(item)" class="iszan"></div>
              </div>
            </div>
            <div v-else>
              <div class="zan" :class="isShow ? 'heartAnimation' : ''">
                <div @click="dian(item)" class="iszan"></div>
              </div>
            </div>
            <div class="bofang">
              <img src="@/assets/images/bofang.png" alt="" />
              <span>{{ item.video_counts | addPriceIcon }}</span>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import newTop from "@/components/travel/newTop.vue";
import { videoList, dianzan } from "@/api/travel";
export default {
  data() {
    return {
      videoElement: [],
      videoList: [],
      ids: 0,
      videos: null,
      timer: null,
      swiperIndex: -1,
      page: 1,
      isShow: false,
      num: 0,
      optionPage: 1,
      arr: [],
    };
  },
  components: {
    newTop,
  },
  filters: {
    //处理函数
    addPriceIcon(value) {
      if (value.toString().length >= 5) {
        return parseFloat(value / 10000).toFixed(1) + "w";
      }
      return value;
    },
  },
  methods: {
    // 播放视频
    changeClick(e) {
      //判断当前的视频是否跟上个一样，如果不一样则取消播放，再次播放下一个
      if (this.ids !== this.videos[e].id) {
        this.videoElement.pause();
      }
      this.videoElement = this.videos[e];
      this.ids = this.videos[e].id;
      //每次划过之前的视频时间重置
      this.videoElement.currentTime = 0;
      // 播放视频
      this.videoElement.play();
      //滑到最后一饿请求列表
      if (e == this.videoList.length - 1) {
        this.page++;
        this.isLoding(e);
      }
    },
    //视频播放事件
    videoPaly(e) {
      //记录播放量接口
      dianzan({
        id: e.srcElement.id,
        type: 1,
        l_type: 1,
      }).then((res) => {
        // console.log(res);
      });
    },
    isEmelent() {
      let flag = true;
      // 获取所有视频元素
      // setTimeout(()=>{
      this.timer = setInterval(() => {
        if (this.videoList.length > 0 && flag) {
          flag = false;
          let video = $(".videos");
          // console.log(video);
          this.videos = video;
          // 播放第一个视频
          this.videoElement = video[this.swiperIndex];
          this.ids = this.videos[this.swiperIndex].id;
          this.videos[this.swiperIndex].play();
          clearInterval(this.timer);
        }
      }, 10);
      // },200)
    },
    // 列表数据 递归，循环请求数据，保证数据不乱
    isLoding(e) {
      if (this.num >= this.optionPage) {
        return;
      }
      let id = this.$route.params.id;
      videoList({
        id: id,
        video_type: 2,
        page: this.num + 1,
        RegIdDistrict: this.$route.params.uid,
      }).then((res) => {
        // console.log(res);
        if (res.videolists.data.length > 0) {
          res.videolists.data.forEach((v) => {
            this.videoList.push(v);
            this.arr.push(v.id);
          });
          //判断用户点到哪个短视频，找到就跳转到那
          if (this.arr.indexOf(parseInt(id)) != -1) {
            this.swiperIndex = this.arr.indexOf(parseInt(id));
            this.$toast.clear();
            this.$nextTick(() => {
              this.isEmelent();
            });
          }
          this.num++;
          this.isLoding();
        }
      });
    },
    //点赞
    dian(item) {
      if (item.user_like == 2) {
        this.isShow = true;
      }
      dianzan({
        id: item.id,
        type: 2,
        l_type: 1,
      }).then((res) => {
        // console.log(res);
        this.isShow = true;
        this.$toast("点赞成功");
      });
    },
  },
  mounted() {},
  created() {
    this.$toast.loading({
      message: "加载中...",
    });
    this.optionPage = this.$route.params.type;
    this.isLoding();
  },
  //页面销毁
  beforeCreate() {
    //清楚定时器
    clearInterval(this.timer);
  },
};
</script>
<style scoped>
.videos {
  height: calc(100vh - 44px);
}
.bjfg {
  width: 100%;
  height: calc(100vh);
  background: #000;
}
.title {
  position: absolute;
  bottom: 10%;
  left: 10px;
  color: #fff;
  text-align: left;
}
.iszan {
  width: 36px;
  height: 36px;
  position: absolute;
  top: 50%;
  left: 30%;
  transform: translateY(-50%);
}
.zan {
  background: url("../../assets/images/web_heart_animation.png");
  background-position: left;
  background-repeat: no-repeat;
  width: 90px;
  height: 90px;
  cursor: pointer;
  position: absolute;
  right: -20px;
  bottom: 26%;
  background-size: 2900%;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bofang {
  width: 26px;
  position: absolute;
  bottom: 26%;
  right: 12px;
  transform: translateY(70%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bofang img {
  width: 100%;
}
.bofang span {
  color: #fff;
  font-size: 12px;
  margin-top: 2px;
}
.heartAnimation {
  display: inline-block;
  -webkit-animation-name: heartBlast;
  animation-name: heartBlast;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-timing-function: steps(28);
  animation-timing-function: steps(28);
  background-position: right;
}
@-webkit-keyframes heartBlast {
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
}

@keyframes heartBlast {
  0% {
    background-position: left;
  }
  100% {
    background-position: right;
  }
}
</style>